let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let esUtils = require("ES/utils/esUtils");
let Constants = require("../../../utils/Constants");
let DeliveryMethodIcon = require("../../widgets/DeliveryMethodIcon");

module.exports = dd.createClass({
	render(){
		let {size, status, closed, delivery_method, has_parent, has_children} = this.props;

		size = esUtils.toInt(size);
		size = size > 0 ? size : 40;

		let icon_size = size/2;
		let sub_icon_size = .4 * size;

		//fixing a font size that doesn't look as good for the on-site icon
		icon_size = (icon_size === 20) ? 21 : icon_size;

		//fixing a font size that doesn't look as good for the family icon
		sub_icon_size = (sub_icon_size === 8) ? 10 : sub_icon_size;

		return dd.div({className: "esStatusImage " + (_.has(Constants.EVENT_STATUSES, status) ? status : "") + (closed ? " closed" : ""), style: {
				position: "relative",
				width: size + "px",
				height: size + "px",
				margin: 0,
				padding: 0,
				fontSize: icon_size + "px",
				textAlign: "center",
				lineHeight: size + "px",
				borderRadius: (size/2) + "px"
			}},
			DeliveryMethodIcon({delivery_method}),
			dd.div({style: {
					position: "absolute",
					top: "auto",
					right: 0,
					bottom: 0,
					left: "auto",
					textAlign: "right",
					fontSize: sub_icon_size + "px",
					lineHeight: sub_icon_size + "px",
					borderRadius: (sub_icon_size/2) + "px",
					color: "#000000",
					backgroundColor: "#FFFFFF"
				}},
				has_parent ? dd.i({className: "fa fa-arrow-circle-up"}) : null,
				has_children ? dd.i({className: "fa fa-arrow-circle-down"}) : null
			)
		);
	}
});



// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/esStatusImage.js